"use client";

import React, { ReactNode, useMemo } from 'react';

import { EnvironmentContext, Environment, EnvironmentContextType } from './environment-context';

interface EnvironmentProviderProps {
    children: ReactNode;
}

const detectEnvironment = (): Environment => {
    const hostname = window.location.hostname;

    if (import.meta.env.MODE === 'development' || import.meta.env.VITE_NODE_ENV === 'dev') {
        return 'development';
    }
    
    if (hostname === 'app.pecunio.ai') {
        return 'production';
    }
    
    if (hostname.startsWith('pecunio-staging')) {
        return 'staging';
    }
    
    return 'development';
};

export const EnvironmentProvider: React.FC<EnvironmentProviderProps> = ({ children }) => {
    const value: EnvironmentContextType = useMemo(() => {
        const environment = detectEnvironment();
        
        return {
            environment,
            isProd: environment === 'production',
            isStaging: environment === 'staging',
            isDev: environment === 'development',
        };
    }, []);

    return (
        <EnvironmentContext.Provider value={value}>
            {children}
        </EnvironmentContext.Provider>
    );
};